
// try {

const searchByZipOnCollectionPageHtml = `
<div class="shipping-filter-zip-section">
  <div class="c-accordion__inner">
    <ul>
      <div class="mt-2">
        <form action="#" class="shippingto-form">
          <div class="form-group d-flex position-relative">
            <img loading="lazy" id="zip-form-2-img-success" src="https://cdn.shopify.com/s/files/1/0521/4047/4568/files/tick-mark.png?v=1683541773" class="success-tick-img hide">

              <input id="zip-form-2" type="text" class="form-control mr-1" placeholder="Type your zip code">
                <button class="" id="btn-zip-form-2" class="d-block py-3">Filter</button>
                <p style="display : none">Invalid Zip</p>
              </div>
              <p id="zip-form-2-error" class="text-center text-invalid hide">
                <p id="zip-form-2-success" class=" text-center text-success hide">These plants will thrive in your area!
                </p>
              </form>
          </div>
        </ul>
      </div>
    </div>`;

  const searchByZipOnCollectionPageWithIconHtml = `<li id="zip-filter-btn" class="slideout__trigger-content inner-addon right-addon success-border hide">
  <img loading="lazy" id="zip-filter-img-success" class="" src="https://cdn.shopify.com/s/files/1/0521/4047/4568/files/shipping-icon.png?v=1683541773">
  <img loading="lazy" id="zip-filter-img-invalid" class="hide" src='https://cdn.shopify.com/s/files/1/0521/4047/4568/files/shipping-icon-failed.png?v=1683541772'>
  <span class="slideout__trigger-collection-sidebar"></span>
</li>`;

const growingZoneOnCollectionPageHtml=`<li id="growing-zone" class="slideout__trigger-content inner-addon right-addon success-border hide">
  <span id="growing-zone-text" class="slideout__trigger-collection-sidebar" style="margin:15px"></span>
</li>`

  const shopByZipCodePlpHeading = `
<span>
  <span id="plp-zipCode-heading-for"></span><span id="plp-zipCode-heading"></span>

</span>`;

  const zipPopupHtml = `<span><link
href="//cdn.shopify.com/s/files/1/0614/1126/2696/t/32/assets/zip-popup.css?v=80117442302304427331678899206"
rel="stylesheet"
type="text/css"
media="all">
<div class="popup-overlay">
<a href="#" class="btn btn-primary d-block py-3"></a>
<div class="container zip-code-modal">
  <div class="row popup w-650 d-flex">
    <div class="span-3-5 auto sm-span-12 d-none-mobile">
      <div class="modal-body img bg-repeat-no h-100 d-flex" style="background-image: url(https://cdn.shopify.com/s/files/1/0521/4047/4568/files/bg-1.jpg?v=1683541772);"></div>
    </div>
    <div class="span-8 auto sm-span-12 p-2-5r">
      <h3>
        Where will you <br>
        be planting?
      </h3>
      <span>We’ll show you which plants will thrive in your area and help local wildlife.
      </span>
      <form class="mt-2">
        <input
          id="zip-form"
          type="text"
          maxlength="6"
          class=""
          placeholder="Enter Zip Code">
        <p id="zip-form-error" class="hide">Invalid Zip</p>
        <button class="" id="btn-zip-form">Submit</button>
        <a class="skip">Skip</a>
      </form>
      <span class="popup-close"></span>
    </div>
  </div>
</div>
</div></span>`;

  const checkoutZipPopupHtml = `
<div id="custom-cart-overlay">
<div class="popup-overlay" style="display: block !important">
<div class="container cart-unavail-modal">
<div class="row popup w-400 m-w-300 h-70 m-h-60 d-table">
  
 <div id="custom-full-cart" class="span-8 auto sm-span-12 p-1r">
 <h3 class="mt-0">These plants are not <br />native to your area.</h3>
 <p class="font-size-15 px-1-5">The following items you added can’t be shipped to your address.</p>
      
       <div id="custom-cart-items">         
      </div>
   
   <div class="buttons">
     <a id="checkout-remove-products" class="btn btn-primary d-block py-3">Remove these Items From my Cart</a>
     <a  class="btn btn-primary d-block py-3 close-cart-popup">Change Address</a>
   </div>
   </div>
  <div id="custom-empty-cart" class="span-8 auto sm-span-12 p-1r hide">
    <div>
     <h1>Let’s find you some new plants!</h1>
        <a class="skip py-3 close-cart-popup">Continue shopping</a>
      </div>
     <span class="popup-close"></span>
    </div>
  <div id="custom-non-empty-cart" class="span-8 auto sm-span-12 p-1r hide">
    <div>
     <h1>These items have been removed from your cart.</h1>
      <a class="skip py-3 close-cart-popup">Continue checkout</a>
      </div>
     <span class="popup-close"></span>
    </div>
</div>
  </div>
</div> 
    </div>`;



  const zipCodeAlert = `<div id="zipcode-alert" style="display : none ">
            <div class="px-3">
<span class="m-s-block"><img loading="lazy" src="" class="position-relative top-3"></span><span>We’re sorry; we don’t yet offer plants for your area. <a target="_blank" href="/pages/out-of-region">Learn more </a>or <a id="zip-alert-cta-2">try a different zip code.</a></span>
</div></div>`

  const zipCodeInvalid = `

          <div id="zipcode-invalid" style="display : none ">
            <div class="px-3">
<span class="m-s-block"><img loading="lazy" src="" class="position-relative top-3"></span><span>We’re sorry; we don’t yet offer plants for your area. <a target="_blank" href="/pages/out-of-region">Learn more </a>or <a id="zip-alert-cta-2">try a different zip code.</a></span>
</div>
          </div>`


  const productInfoHtml = `
<p id="p-t-PRODUCT_ID_TEMP_VALUE" style="opacity : 0;width : 0;height : 0">PRODUCT_TYPE_TEMP_VALUE</p>
`
  const BACKEND_SERVER_URL = "https://zip-app.gardenforwildlife.com/script-test";

  var salesForceUrl = 'https://nwf--uat.sandbox.my.site.com'
  
  const config = {
      customUtilTargetId: "slideout-ajax-cart",
      zipPopupTargetId: "shopify-section-template-zipcode",
      checkoutZipTargetId: "shopify-digital-wallet",
      cartZipValidationTargetId: "AddToCartForm",
  };

  const htmlConfig = {
      collectionPlpHeading: {
          selector: "h1",
          position: 0
      },
      collectionSearchByZip: {
          selector: ".grid__wrapper",
          position: 2
      },
      collectionSearchByZipWithIcon: {
          selector: ".collection__topbar-controls",
          position: 0
      },
      collectionZipPopup: {
          selector: "main",
          position: 0
      },
      collectionZipcodeAlert: {
          selector: ".result-section",
          position: 0
      },
      productConfirmAvailability: {
          selector: "#AddToCartForm",
          position: 0
      },
      checkoutPopup: {
          selector: "body",
          position: 0
      }


  }

  function isCollectionPage() {
      if (window.location.pathname.includes("/collections/")&& !window.location.pathname.includes("/products")) {
          return true
      }
      else {
          return false
      }
  }

  function isProductPage() {
    let urlPaths=window.location.pathname.split("/")
      if (urlPaths[urlPaths.length-2].toLowerCase()==="products") {
          return true
      }
      else {
          return false
      }
  }

  function isCheckoutPage() {
       if ((window.location.pathname.includes("checkout") && window.location.search.includes("?step=contact_information")) || (window.location.pathname.includes("checkout") && window.location.search.includes(""))) {
          return true;
      } else {
          return false;
      }
  }

  function getActivePage() {
      // if (isCollectionPage()) {
      //     return "collection"
      // }
      if (isProductPage()) {
          return "product"
      }
      // else if (isCheckoutPage()) {
      //     return "checkout"
      // }
      else {
          return null
      }
  }

  function addElement(parentNode, nodeToInsert, method = "append") {
      if (method == "append") {
          parentNode?.appendChild(nodeToInsert)
      }
      else if (method == "prepend") {
          parentNode?.prepend(nodeToInsert)
      }

  }

  function createNode(tageName, html) {
      let newNode = document.createElement(tageName)
      newNode.innerHTML = html
      return newNode.firstElementChild;
  }

 

  function insertCollectionPageTemplates() {

      let isZip=document.getElementById("templateIdentify");
      if(!isZip){
      let newNodePlpHeading = createNode("div", shopByZipCodePlpHeading)
      addElement(document.querySelectorAll(htmlConfig.collectionPlpHeading.selector)[htmlConfig.collectionPlpHeading.position], newNodePlpHeading)
      // --------------------------------------------------------------
      let newNodeSearchZip = createNode("div", searchByZipOnCollectionPageHtml)
      addElement(document.querySelectorAll(htmlConfig.collectionSearchByZip.selector)[htmlConfig.collectionSearchByZip.position], newNodeSearchZip)
      // --------------------------------------------------------------
      let newNodeSearchZipWithIcon = createNode("div", searchByZipOnCollectionPageWithIconHtml)
      addElement(document.querySelectorAll(htmlConfig.collectionSearchByZipWithIcon.selector)[htmlConfig.collectionSearchByZipWithIcon.position], newNodeSearchZipWithIcon)

      let newNodeGrowingZone = createNode("div", growingZoneOnCollectionPageHtml)
      addElement(document.querySelectorAll(htmlConfig.collectionSearchByZipWithIcon.selector)[htmlConfig.collectionSearchByZipWithIcon.position], newNodeGrowingZone)
    
      // --------------------------------------------------------------
      let newNodeZipPopup = createNode("div", zipPopupHtml)
      addElement(document.querySelectorAll(htmlConfig.collectionZipPopup.selector)[htmlConfig.collectionZipPopup.position], newNodeZipPopup)
      // ----------------------------------
      let newNodeZipcodeALert = createNode("div", zipCodeAlert)
      addElement(document.querySelectorAll(htmlConfig.collectionZipcodeAlert.selector)[htmlConfig.collectionZipcodeAlert.position], newNodeZipcodeALert)
      let newNodeZipcodeInvalid = createNode("div", zipCodeInvalid)
      addElement(document.querySelectorAll(htmlConfig.collectionZipcodeAlert.selector)[htmlConfig.collectionZipcodeAlert.position], newNodeZipcodeInvalid)
      }
  }

  function insertProductPageTemplates() {

    let productSearchUrl=window.location.href.replace(window.location.search,"")+".json"
      fetch(productSearchUrl)
          .then((response) => response.json())
          .then((data) => {
              const productID = data["product"]["id"];
              const productType = data["product"]["product_type"]
              console.log(productID, productType);
              let newNodeProductInfo = createNode("div", productInfoHtml.replace("PRODUCT_ID_TEMP_VALUE", productID).replace("PRODUCT_TYPE_TEMP_VALUE", productType))
              addElement(document.querySelectorAll(htmlConfig.productConfirmAvailability.selector)[htmlConfig.productConfirmAvailability.position], newNodeProductInfo, "prepend")
            
          });

      // --------------------------------------------------------------

  }

  function insertCheckoutPageTemplates() {

      // window.onload = function () {
          let newNodeCheckoutPopup = createNode("div", checkoutZipPopupHtml)
          addElement(document.querySelectorAll(htmlConfig.checkoutPopup.selector)[htmlConfig.checkoutPopup.position], newNodeCheckoutPopup)
       

      // };

      // --------------------------------------------------------------

  }

  function insertPageTemplates() {
      switch (getActivePage()) {
          case "collection":
              console.log("collection")
              // insertHeaderBenefits()
              insertCollectionPageTemplates()
              break;
          case "product":
              console.log("product")
              // insertHeaderBenefits()
              insertProductPageTemplates()
              break;
          case "checkout":
              console.log("checkout")
              insertCheckoutPageTemplates()
              break
          default:
              console.log("page not found")


      }
  }
  // ---------------------------------------------------------------------

  function injectCustomUtilsScript() {
      var customUtlisTarget = document.getElementById(config.customUtilTargetId);
      if (customUtlisTarget) {
          const customUtlisScript = document.createElement("script");
          customUtlisScript.setAttribute(
              "src",
              BACKEND_SERVER_URL + "/custom-utils.js"
          );
          customUtlisTarget.after(customUtlisScript);
         
      }
  }
  // ----------------------------------------------------------------------
  function injectCollectionScript() {
      
      const zipPopupScript = document.createElement("script");
      zipPopupScript.setAttribute("src", BACKEND_SERVER_URL + "/zip-popup.js");
   
      addElement(document.querySelectorAll(htmlConfig.checkoutPopup.selector)[htmlConfig.checkoutPopup.position], zipPopupScript)
  }
  // ---------------------------------------------------------------------
  function injectCheckoutScript() {
     
      let checkoutZipScript = document.createElement("script");
      checkoutZipScript.setAttribute(
          "src",
          BACKEND_SERVER_URL + "/checkout-zip-validation.js"
      );
     
      addElement(document.querySelectorAll(htmlConfig.checkoutPopup.selector)[htmlConfig.checkoutPopup.position], checkoutZipScript, "prepend")
      // }
  }
  // ---------------------------------------------------------------------
  function injectProductScript() {
     
      const cartZipValidationScript = document.createElement("script");
      cartZipValidationScript.setAttribute(
          "src",
          BACKEND_SERVER_URL + "/cart-zip-validation.js"
      );
   
      addElement(document.querySelectorAll(htmlConfig.checkoutPopup.selector)[htmlConfig.checkoutPopup.position], cartZipValidationScript)
  }

  function injectScripts() {
      switch (getActivePage()) {
          // case "collection":
          //     console.log("collection")
          //     injectCustomUtilsScript()
          //     injectCollectionScript()
          //     break;
          case "product":
              console.log("product")
              injectCustomUtilsScript()
              injectProductScript()
              break;
          // case "checkout":
          //     console.log("checkout")
          //     injectCheckoutScript()
          //     break
          default:
              console.log("page not found")


      }
  }

 
  // ---------------------------------------------------------------------
 

  document.addEventListener('readystatechange', event => {
      // When HTML/DOM elements are ready:
      if (event.target.readyState === "interactive") {
          //does same as:  ..addEventListener("DOMContentLoaded"..
          insertPageTemplates()
          injectScripts()
      }
      // When window loaded ( external resources are loaded too- `css`,`src`, etc...) 
      if (event.target.readyState === "complete") {
          // insertPageTemplates()
      }
  });

  window.onload = function () {
      // insertPageTemplates()
  }
// } catch (error) {
//     console.log("------------- Error", error);
// }